// extracted by mini-css-extract-plugin
module.exports = {"container":"activities_container__1oEda"};